/**
 * Top Sprites — non-interactive decorative pixel-art characters in a band at the
 * top of every page (except the home page, which keeps its interactive hero sprites).
 *
 * Uses the SAME characters as the hero (assets/js/sprites.js), purely as a
 * background: no speech bubbles, no hover/tap, pointer-events disabled via CSS.
 * Two layouts: the hero's U-shape band (default), or — when the container has
 * data-sprites-rails (collection pages) — 3 smaller sprites per side gutter,
 * kept outside the content column.
 */
(function () {
    'use strict';

    var container = document.querySelector('[data-top-sprites]');
    if (!container) return;

    // Collection pages (blogs/podcasts/videos) opt into the side-rail layout via
    // data-sprites-rails on the container; all other pages keep the hero U-shape.
    var rails = container.hasAttribute('data-sprites-rails');

    var PX = 4; // Same cell size as the hero sprites (10×14 grid = 40×56px art)
    var SCALE = rails ? 0.85 : 1; // Rails render 15% smaller (~34×48px)

    // Palette: 0=transparent, 1=skin, 2=hair, 3=shirt, 4=pants, 5=accent/shoes, 6=prop
    // Same grids/palettes as the hero characters (no dialog lines needed here).
    var characters = [
        { palette: ['transparent','#f2c9a0','#4b2e1f','#3b82f6','#1e3a8a','#93c5fd','#64748b'],
          grid: [
            [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],[0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,3,0],
            [0,1,3,3,3,3,3,3,1,0],[0,0,1,6,6,6,6,1,0,0],[0,0,0,6,6,6,6,0,0,0],[0,0,0,4,4,4,4,0,0,0],
            [0,0,0,4,0,0,4,0,0,0],[0,0,0,5,0,0,5,0,0,0]
          ] },
        { palette: ['transparent','#e8b98d','#2f2f2f','#f59e0b','#7c2d12','#fde68a','#a855f7'],
          grid: [
            [0,0,6,2,2,2,2,6,0,0],[0,6,2,2,2,2,2,2,6,0],[0,6,1,1,1,1,1,1,6,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,3,0],
            [0,0,3,3,3,3,3,3,0,0],[0,0,0,3,3,3,3,0,0,0],[0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
            [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
          ] },
        { palette: ['transparent','#f0c7a4','#312e81','#8b5cf6','#4c1d95','#ddd6fe','#92400e'],
          grid: [
            [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],[0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,3,0],
            [0,0,3,3,3,3,1,0,0,0],[0,0,0,3,3,3,1,6,6,0],[0,0,0,4,4,4,0,6,6,0],[0,0,0,4,0,0,4,0,0,0],
            [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
          ] },
        { palette: ['transparent','#d9a679','#7f1d1d','#ef4444','#7f1d1d','#fecaca','#334155'],
          grid: [
            [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],[0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,1,0,0],
            [0,0,3,3,3,3,1,6,0,0],[0,0,0,3,3,3,0,6,0,0],[0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
            [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
          ] },
        { palette: ['transparent','#cfa07a','#14532d','#22c55e','#166534','#bbf7d0','#e2e8f0'],
          grid: [
            [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],[0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,1,6,6],
            [0,0,3,3,3,3,3,0,6,6],[0,0,0,3,3,3,3,0,6,6],[0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
            [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
          ] },
        { palette: ['transparent','#f2c9a0','#0f172a','#06b6d4','#164e63','#a5f3fc','#f59e0b'],
          grid: [
            [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],[0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[0,0,3,3,3,3,3,3,0,0],[0,1,3,3,3,3,3,3,1,0],
            [0,0,1,6,6,6,6,1,0,0],[0,0,0,6,6,6,6,0,0,0],[0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
            [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
          ] },
        { palette: ['transparent','#e5b38a','#78350f','#eab308','#854d0e','#fde047','transparent'],
          grid: [
            [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],[0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,1,0],
            [0,0,3,3,3,3,3,0,1,0],[0,0,0,3,3,3,3,0,1,0],[0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
            [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
          ] },
        { palette: ['transparent','#e7bc96','#450a0a','#f43f5e','#881337','#fda4af','#a16207'],
          grid: [
            [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],[0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[0,0,3,3,3,3,3,3,0,0],[0,1,6,6,6,6,6,6,1,0],
            [0,0,6,6,6,6,6,6,0,0],[0,0,6,6,6,6,6,6,0,0],[0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
            [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
          ] },
        { palette: ['transparent','#e0b088','#365314','#84cc16','#3f6212','#d9f99d','transparent'],
          grid: [
            [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],[0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,3,0],
            [0,0,3,3,3,3,3,3,0,0],[0,1,0,3,3,3,3,0,1,0],[0,4,4,4,4,4,4,4,4,0],[0,0,4,4,4,4,4,4,0,0],
            [0,0,5,0,0,0,0,5,0,0],[0,0,0,0,0,0,0,0,0,0]
          ] },
        { palette: ['transparent','#e8bc98','#1e1b4b','#6366f1','#312e81','#c7d2fe','transparent'],
          grid: [
            [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],[0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
            [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],[1,0,3,3,3,3,3,3,0,1],[0,1,3,3,3,3,3,3,1,0],
            [0,0,3,3,3,3,3,3,0,0],[0,0,0,3,3,3,3,0,0,0],[0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
            [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
          ] }
    ];

    // Rails: two vertical side rails in the page gutters, OUTSIDE the 1280px content
    // column, so sprites never sit behind the page title, tables or cards. Each offset
    // hugs the column edge on wide screens (calc) and clamps to the viewport edge on
    // narrower ones (the vw term). Sprite art is ~34px wide; the column starts at
    // calc(50% - 640px), so an offset of calc(50% - 688px) leaves a comfortable gap.
    // 3 per side with generous vertical gaps so the rails don't feel cluttered.
    var railPositions = [
        { side: 'left',  x: 'max(0.5vw, calc(50% - 688px))', y: '8%',  tier: 1 },
        { side: 'right', x: 'max(0.8vw, calc(50% - 700px))', y: '14%', tier: 1 },
        { side: 'left',  x: 'max(1vw, calc(50% - 678px))',   y: '40%', tier: 2 },
        { side: 'right', x: 'max(0.6vw, calc(50% - 692px))', y: '46%', tier: 2 },
        { side: 'left',  x: 'max(0.6vw, calc(50% - 694px))', y: '72%', tier: 3 },
        { side: 'right', x: 'max(1vw, calc(50% - 676px))',   y: '78%', tier: 3 }
    ];

    // Default: same U-shape layout as the hero, keeping the horizontal center clear.
    var bandPositions = [
        { x: '8%',  y: '8%',  tier: 1 },
        { x: '84%', y: '10%', tier: 1 },
        { x: '10%', y: '35%', tier: 2 },
        { x: '82%', y: '33%', tier: 2 },
        { x: '8%',  y: '60%', tier: 1 },
        { x: '84%', y: '58%', tier: 1 },
        { x: '12%', y: '80%', tier: 3 },
        { x: '80%', y: '78%', tier: 3 },
        { x: '24%', y: '84%', tier: 3 },
        { x: '70%', y: '82%', tier: 3 }
    ];

    var positions = rails ? railPositions : bandPositions;

    function shuffle(arr) {
        for (var i = arr.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
        }
        return arr;
    }

    shuffle(characters);

    function buildSVG(char) {
        var cols = char.grid[0].length;
        var rows = char.grid.length;
        var w = cols * PX;
        var h = rows * PX;
        var rects = [];
        for (var r = 0; r < rows; r++) {
            for (var c = 0; c < cols; c++) {
                var idx = char.grid[r][c];
                if (idx === 0) continue;
                rects.push(
                    '<rect x="' + (c * PX) + '" y="' + (r * PX) +
                    '" width="' + PX + '" height="' + PX +
                    '" fill="' + char.palette[idx] + '"/>'
                );
            }
        }
        return '<svg class="dev-sprite__art" width="' + (w * SCALE) +
               '" height="' + (h * SCALE) + '" viewBox="0 0 ' + w + ' ' + h +
               '" xmlns="http://www.w3.org/2000/svg">' +
               rects.join('') + '</svg>';
    }

    // Inject sprites — art only, no speech bubbles, no interaction handlers.
    var frag = document.createDocumentFragment();
    positions.forEach(function (pos, i) {
        var char = characters[i % characters.length];
        var el = document.createElement('div');
        el.className = 'dev-sprite';
        el.setAttribute('data-sprite-tier', String(pos.tier));
        if (pos.side === 'right') {
            el.style.right = pos.x;
        } else {
            el.style.left = pos.x;
        }
        el.style.top = pos.y;
        el.innerHTML = buildSVG(char);
        frag.appendChild(el);
    });
    container.appendChild(frag);
})();
